export default "__VITE_ASSET__DJbkKDtk__"